import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './shared/layout/main/main.component';
import { LayoutModule } from './shared/layout/layout.module';
import { LoginComponent } from './features/login/login.component';
import { HomeComponent } from './features/home/home.component';
import { FarmDetailComponent } from './features/farm-detail/farm-detail.component';
import { SchedualDetailComponent } from './features/schedual-detail/schedual-detail.component';
import { ManageThingComponent } from './features/manage-thing/manage-thing.component';
import { PlotComponent } from './features/plot/plot.component';
import { ManageUserComponent } from './features/manage-user/manage-user.component';
import { CreateUserComponent } from './features/create-user/create-user.component';
import { DrawFarmComponent } from './features/draw-farm/draw-farm.component';
import { FarmDashboardComponent } from './features/farm-dashboard/farm-dashboard.component';
import { PlotEventComponent } from './features/plot-event/plot-event.component';
import { CreateCropComponent } from './features/create-crop/create-crop.component';
import { PreloadComponent } from './features/preload/preload.component';
import { ReportComponent } from './features/report/report.component';
import { PreloadPlotDetailComponent } from './features/preload-plot-detail/preload-plot-detail.component';
import { ConfigColorComponent } from './features/config-color/config-color.component';
import { OverviewGraphComponent } from './features/graph/overview-graph/overview-graph.component';
import { OverviewGraphHistoryComponent } from './features/graph-history/overview-graph-history/overview-graph-history.component';
import { ReportOverviewComponent } from './features/report/report-overview/report-overview.component';
import { ManageYieldListComponent } from './features/manage-yield/manage-yield-list/manage-yield-list.component';
import { ManageYieldEditComponent } from './features/manage-yield/manage-yield-edit/manage-yield-edit.component';
import { ManageYieldViewComponent } from './features/manage-yield/manage-yield-view/manage-yield-view.component';
import { ManageFarmListComponent } from './features/manage-farm/manage-farm-list/manage-farm-list.component';
import { ManageFarmCreateComponent } from './features/manage-farm/manage-farm-create/manage-farm-create.component';
import { ManageFarmViewComponent } from './features/manage-farm/manage-farm-view/manage-farm-view.component';
import { ManageFarmEditComponent } from './features/manage-farm/manage-farm-edit/manage-farm-edit.component';
import { ManageFarmPlotCreateComponent } from './features/manage-farm/manage-farm-plot-create/manage-farm-plot-create.component';
import { ManageFarmPlotEditComponent } from './features/manage-farm/manage-farm-plot-edit/manage-farm-plot-edit.component';
import { YieldReportSubComponent } from './features/yield-report-sub/yield-report-sub.component';
import { ManageThingListComponent } from './features/manage-thing/manage-thing-list/manage-thing-list.component';
import { WeatherForecastComponent } from './features/weather-forecast/weather-forecast/weather-forecast.component';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },
      { path: 'plot/:id', component: PlotComponent},
      { path: 'manage-thing/:farm/:plot', component: ManageThingComponent},
      { path: 'manage-user', component: ManageUserComponent},
      { path: 'create-user', component: CreateUserComponent},
      { path: 'draw-farm', component: DrawFarmComponent},
      { path: 'dashboard', component: FarmDashboardComponent},
      { path: 'create-crop', component: CreateCropComponent},
      { path: 'plot-detail', component: FarmDetailComponent},
      { path: 'schedule-detail',component: SchedualDetailComponent},
      { path: 'plot-event',component: PlotEventComponent},
      { path: 'report', component: ReportComponent },
      { path: 'preload-plot-detail', component: PreloadPlotDetailComponent },
      { path: 'report/graph', component: OverviewGraphComponent },
      { path: 'report/history', component: OverviewGraphHistoryComponent },
      { path: 'report/report', component: ReportOverviewComponent },
      { path: 'manage-yield', component: ManageYieldListComponent },
      { path: 'manage-yield/:yield_template_id/view', component: ManageYieldViewComponent },
      { path: 'manage-yield/:yield_template_id/edit', component: ManageYieldEditComponent },

      { path: 'manage-farm', component: ManageFarmListComponent },
      { path: 'manage-farm/create', component: ManageFarmCreateComponent },
      { path: 'manage-farm/:id/:name/view', component: ManageFarmViewComponent },
      { path: 'manage-farm/:id/:name/edit', component: ManageFarmEditComponent },
      
      { path: 'manage-farm/:id/:name/plot/createPlot', component: ManageFarmPlotCreateComponent },
      { path: 'manage-farm/plot/:plot_id/:plot_name/editPlot', component: ManageFarmPlotEditComponent },
      { path: 'yield-report-sub', component: YieldReportSubComponent },

      { path: 'manage-thing', component: ManageThingListComponent },
      // { path: 'weather-forecast', component: WeatherForecastComponent },
      //test
    ],
    // canActivate: [AuthGuard]
  },
  { path: 'config-color', component: ConfigColorComponent },
  {
    path: 'login', component: LoginComponent
  },
  {
    path: 'preload', component: PreloadComponent
  },

  { path: '**', redirectTo: "" }
];

@NgModule({
  imports: [LayoutModule, RouterModule.forRoot(routes, { useHash: true })],
  bootstrap: [],
  exports: [RouterModule]
})
export class AppRoutingModule { }
